import { Tag } from 'antd'

import { classNames } from '@/Ship/Helpers/classNames'

import type { IReportUser } from '../Contracts/IReportPeriod'

import styles from './Report.module.css'

/**
 * ПІБ у рядку звіту по логістах. Деактивований потрапляє у звіт лише з
 * даними за період і несе позначку (Q3.7, Ф-02, З-01).
 */
export const ReportUserCell = ({ user }: { user: IReportUser }) => (
    <span className={classNames(styles['userCell'])}>
        <span>{user.fullName ?? '—'}</span>
        {user.isActive ? null : (
            <Tag className={classNames(styles['mark'])} data-testid="report-user-inactive">
                деактивований
            </Tag>
        )}
    </span>
)
